module.exports = "<div class=\"<%= term %>\">{{ $ctrl.term }}</div>\r\n<div class=\"definition\" ng-transclude></div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/definition-list/Definition/Definition.html
// module id = 909
// module chunks = 0